<script>
  import * as t3dApp from "../model/model";
  export let mps;
  export let markPoint;
  export let markStatus;

  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  /**
   * sizeNum用于判断尺寸按钮的状态（是否被选中）
   * markNum用于判断标注按钮的状态（是否被选中）
   */

  let sizeNum = 0;
  let markNum = 0;

  // 定义尺寸按钮点击事件
  function sizeBtnClick() {
    if (sizeNum == 0) {
      sizeNum = 1;
      markNum = 0;
      markPoint = 0;
      markStatus = 0;
      //  markNums[0] = 0
      // markNum1 = 0;
      t3dApp.showGroup("maße");
      t3dApp.tweenCameraFuc("startCamera", "startTarget", "0.6");
    } else {
      sizeNum = 0;
      t3dApp.hideGroup("maße");
    }
    dispatch("sendMessage", {
      message: 0,

      // markStatus: markStatus
    });
  }
  function markBtnClick() {
    mps.forEach((element, index) => {
      t3dApp.bindPoint(element, `pointTarget${index + 1}`);
    });

    // t3dApp.bindPoint(`markPoint1`,"pointTarget1")
    if (markNum == 0) {
      markNum = 1;
      markPoint = 1;
      sizeNum = 0;
      t3dApp.hideGroup("maße");
      t3dApp.tweenCameraFuc("startCamera", "startTarget", "0.6");
    } else {
      markNum = 0;
      markPoint = 0;
      // markNum1 = 0;
      console.log("aaa");
      t3dApp.eventControl("enableZoom", true);
      t3dApp.tweenCameraFuc("startCamera", "startTarget", "0.6");
    }
    dispatch("message", {
      text: markPoint,
    });
  }
</script>

<div class="TopBtn">
  <div
    id="size"
    class={sizeNum == 0 ? "Btn leftBtn" : "BtnClick leftBtn"}
    on:click={sizeBtnClick}
  >
    Maße
  </div>
  <div
    id="mark"
    class={markNum == 0 ? "Btn rightBtn" : "BtnClick rightBtn"}
    on:click={markBtnClick}
  >
    <!-- Komponenten&thinsp;/&thinsp;Dokumente -->
    Service
  </div>
</div>

<style>
  .TopBtn {
    text-align: center;
    user-select: none;
    cursor: pointer;
    position: relative;
  }
  .TopBtn div {
    display: inline-block;
    width: 136px;
    height: 43px;
    border: 0.5px solid #3380c4;
    margin: 10px 0px;
    letter-spacing: 0.8px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 6px;
    line-height: 42px;
    user-select: none;
    box-sizing: border-box;
    font-family: "Lato", sans-serif;
  }
  #mark {
    /* width: auto; */
    padding: 0 5px;
  }
  .Btn {
    background-color: #fdfdfd;
    color: #0089ca;
    position: absolute;
    z-index: 1000;
  }
  .BtnClick {
    background-color: #0089ca;
    color: #fdfdfd;
    position: absolute;
  }

  .leftBtn {
    left: 50%;
    transform: translate(calc(-100% - 5px));
  }

  .rightBtn {
    left: 50%;
    transform: translate(5px);
  }
</style>
